export default class Recaptcha {
  constructor ({ recaptcha_response = null } = {}) {
    this.recaptcha_response = recaptcha_response
  }
}